<template>
  <div class="goods-cell brick-item cursor" @click="go(`/home/detail?id=${goods.goods_id}`)">
    <div class="img-box" @mouseenter="show = true" @mouseleave="show = false">
      <el-image :src="goods.goods_img" lazy></el-image>
      <div
          class="delete_icon fr ac jc cursor"
          v-if="type != 'show' && show"
          @click.stop="insertCollection"
      >
        <i class="el-icon-delete white fz16"></i>
      </div>
      <img v-if="Number(goods.is_promote) === 1" class="icon-promotion" src="/static/imgs/icon_promotion.png"/>
    </div>
    <p class="ellipsis-2line mt10 fz12 pl10">{{ goods.goods_name }} {{ goods.goods_standard_name }}</p>
    <!--    <p class="mt10 fz12 orange pl10">￥{{ goods.goods_price }}</p>-->
    <p class="mt10 fz12 orange pl10">
      <span class="fz12">￥</span>
      <span class="fz14 ">{{ goods.minMaxPriceGoodsSpecification[0].show_price }}</span>
      <template v-if="goods.minMaxPriceGoodsSpecification.length === 2">
        <span class="fz12 black">~</span>
        <!--              <span class="fz16">￥</span>-->
        <span class="fz14 ">{{ goods.minMaxPriceGoodsSpecification[1].show_price }}</span>
      </template>
      <span v-else class="fz14 ml10">起</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    goods: Object,
    type: {
      type: String,
      default: "show"
    }
  },
  data() {
    return {
      show: false,
      item: this.$props.goods
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.is_Empty(this.$props.goods)) return;
      let obj = this.deepClone(this.$props.goods);
      obj.minMaxPriceGoodsSpecification.forEach(el => {
        el.show_price = (!this.is_Empty(this.$store.state.sale_info) || this.$store.state.is_sales) ? el.specification_price : el.show_price
      });
      this.item = this.deepClone(obj);
    },
    insertCollection() {
      this.$emit("insertCollection", {
        collection_id: this.goods.goods_id,
        collection_type: 1
      });
    }
  }
};
</script>

<style scoped lang="scss">
.goods-cell {
  width: 205px;
  height: 280px;
  padding-bottom: 10px;
  margin-bottom: 10px;

  .img-box {
    position: relative;

    .icon-promotion {
      width: 80px;
      position: absolute;
      top: 0;
      left: 0;
    }

    .el-image {
      width: 100%;
      height: 200px;
    }

    .delete_icon {
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoodsCell.vue